import { GridColumn } from '../../../../../../generic/grid-table'
import { IMetaDataQ4 } from '../../../../../../modules/API/Reports/models/q4'
import { formatFixed, formatNumber } from '../helpers/formatNumber'
import { REPORT_FIELD_KEYS } from '../helpers/reportRows'
import { ReportRow } from '../types/row'

const formatPricePerKg = (value: ReportRow[keyof ReportRow]): string =>
  typeof value === 'number' ? value.toFixed(2) : ''

const formatRevenue = (value: ReportRow[keyof ReportRow]): string =>
  typeof value === 'number' ? String(formatNumber(value)) : ''

const formatWeight = (value: ReportRow[keyof ReportRow]): string =>
  typeof value === 'number' ? formatFixed(value) : ''

/** Dynamic columns follow the report's MetaData (blank labels are hidden), then the fixed metrics. */
export const buildReportColumns = (meta: IMetaDataQ4): GridColumn<ReportRow>[] => [
  ...REPORT_FIELD_KEYS.filter((key) => meta[key]?.trim()).map(
    (key): GridColumn<ReportRow> => ({
      key: `${key}_Label`,
      title: meta[key],
      dataType: 'string',
      sortable: true,
    }),
  ),
  { key: 'AmountPack', title: 'אריזות', dataType: 'number', sortable: true },
  { key: 'AmountPallets', title: 'משטחים', dataType: 'number', sortable: true },
  { key: 'Weight', title: 'משקל', dataType: 'float', sortable: true, formatValue: formatWeight },
  { key: 'PricePerKg', title: 'מחיר', dataType: 'float', sortable: true, formatValue: formatPricePerKg },
  { key: 'Price', title: 'פדיון', dataType: 'float', sortable: true, formatValue: formatRevenue },
]
